import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/brevo/')({
  loader: () => {
    throw redirect({
      to: '/brevo/events',
      replace: true,
    })
  },
})
